import { FC } from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, ButtonBase } from '@mui/material';
import { dailyNavRecordNeedsReview, REVIEW_PRICE_LABEL } from 'pages/Intelligence/DailyNav/dailyNav.constants';
import { ReviewPriceCellProps } from './ReviewPriceCell.props';

// Colors match the monitoring prototype exactly (Tailwind red-600 / slate-400).
const NEEDS_REVIEW_COLOR = '#dc2626';
const NEEDS_REVIEW_HOVER_COLOR = '#b91c1c';
const REVIEWED_COLOR = '#94a3b8';
const REVIEWED_HOVER_COLOR = '#64748b';

const ReviewPriceCell: FC<ReviewPriceCellProps> = ({ row, onReviewClick, canReview }) => {
  const needsReview = dailyNavRecordNeedsReview(row.record);

  const baseColor = needsReview ? NEEDS_REVIEW_COLOR : REVIEWED_COLOR;
  const activeHoverColor = needsReview ? NEEDS_REVIEW_HOVER_COLOR : REVIEWED_HOVER_COLOR;
  // Read-only buttons stay flat on hover; interactive ones darken.
  const hoverColor = canReview ? activeHoverColor : baseColor;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
      <ButtonBase
        id={`review-price-button-${row.companyId}`}
        // Review Price is for firm editors and staff; others get an inert, read-only button.
        disabled={!canReview}
        onClick={canReview ? () => onReviewClick(row) : undefined}
        sx={{
          alignItems: 'center',
          backgroundColor: baseColor,
          borderRadius: '4px',
          color: '#fff',
          cursor: canReview ? 'pointer' : 'default',
          display: 'inline-flex',
          fontSize: 10,
          fontWeight: 600,
          gap: '4px',
          height: 18,
          lineHeight: 1,
          padding: '2px 8px',
          whiteSpace: 'nowrap',
          '&:hover': {
            backgroundColor: hoverColor,
          },
        }}>
        {needsReview && <WarningAmberIcon sx={{ fontSize: 11 }} />}
        {REVIEW_PRICE_LABEL}
      </ButtonBase>
    </Box>
  );
};

export default ReviewPriceCell;
